/* Small rotating spinner used inside buttons ("Sending…", "Regenerating…").
   variant="green" matches the ghost-button styling from the prototype. */
export default function Spinner({ variant }) {
  const style =
    variant === 'green'
      ? { borderColor: 'rgba(24,99,56,.25)', borderTopColor: 'var(--green)' }
      : undefined;
  return <span className="regen-spin" style={style} />;
}
